export type TipoSaludo = 'texto' | 'audio' | 'emoji' | 'imagen';

export type DestinoSaludo = 'radio' | 'programa' | 'locutor' | 'evento';

export type EstadoSaludo = 'recibido' | 'leido' | 'destacado' | 'al_aire';

export interface Saludo {
  id: number;
  tipo: TipoSaludo;
  texto: string;
  audioDuracion?: string;
  emoji?: string;
  imagenUrl?: string;
  remitente: string;
  remitenteAvatar: string;
  remitenteCiudad: string;
  destino: DestinoSaludo;
  destinoNombre: string;
  destinoRadio: string;
  estado: EstadoSaludo;
  fechaEnvio: string;
  fechaLeido?: string;
  fechaDestacado?: string;
  fechaAlAire?: string;
  compartidos: number;
  score: number;
}

export interface ScoreAccionSaludo {
  id: string;
  accion: string;
  icono: string;
  color: string;
  descripcion: string;
  puntos: number;
}

export interface ReglaSaludo {
  id: number;
  titulo: string;
  descripcion: string;
  icono: string;
  color: string;
}

export const coverImage = 'https://readdy.ai/api/search-image?query=Warm%20golden%20studio%20broadcast%20room%20with%20soft%20warm%20lighting%20and%20pleasant%20ambient%20atmosphere%2C%20soundproof%20panels%20in%20warm%20cream%20tones%2C%20microphone%20on%20a%20wooden%20desk%2C%20cozy%20and%20inviting%20environment%2C%20professional%20broadcast%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20color%20palette%20of%20amber%20and%20cream&width=1600&height=900&seq=saludos-hero-x1&orientation=landscape';

export const saludos: Saludo[] = [
  {
    id: 1,
    tipo: 'texto',
    texto: 'Un saludo enorme para toda la gente de San José que nos escucha desde temprano. ¡Arriba el barrio El Carmen! Y un abrazo especial para mi esposa Andrea que hoy está de cumpleaños.',
    remitente: 'Carlos Ramírez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20friendly%20face%2C%20casual%20polo%20shirt%2C%20natural%20daylight%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=saludo-carlos&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'radio',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'al_aire',
    fechaEnvio: '2026-06-21T14:22:00',
    fechaLeido: '2026-06-21T14:25:00',
    fechaAlAire: '2026-06-21T14:28:00',
    compartidos: 124,
    score: 310,
  },
  {
    id: 2,
    tipo: 'texto',
    texto: 'Saludos para todo el equipo, son los mejores. Especialmente para Natalia que nos alegra las mañanas y a Diego que siempre me hace reír con sus comentarios. ¡Los quiero mucho!',
    remitente: 'Sofía Hernández',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20trendy%20casual%20style%2C%20bright%20genuine%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=saludo-sofia&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'locutor',
    destinoNombre: 'Valentina Ríos',
    destinoRadio: 'Estéreo Capital',
    estado: 'destacado',
    fechaEnvio: '2026-06-21T14:18:00',
    fechaLeido: '2026-06-21T14:20:00',
    fechaDestacado: '2026-06-21T14:25:00',
    compartidos: 89,
    score: 267,
  },
  {
    id: 3,
    tipo: 'audio',
    texto: 'Hola equipo, les mando este audio porque escribir no alcanza. Quiero agradecerles por acompañarme todas las mañanas camino al trabajo. Son mi terapia diaria. ¡Pura vida!',
    audioDuracion: '0:42',
    remitente: 'Tomás Blanco',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20creative%20style%2C%20thoughtful%20expression%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=saludo-tomas&orientation=squarish',
    remitenteCiudad: 'Alajuela',
    destino: 'radio',
    destinoNombre: 'Radio Deportiva Total 95.7',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'recibido',
    fechaEnvio: '2026-06-21T14:15:00',
    compartidos: 0,
    score: 10,
  },
  {
    id: 4,
    tipo: 'texto',
    texto: 'Bendiciones para todo el equipo de Radio Frecuencia. Hoy celebro 10 años de escucharlos todas las mañanas. Son mi compañía fiel camino al trabajo. ¡Gracias por tanto!',
    remitente: 'Ana Patricia Vega',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20Latina%20woman%2C%20elegant%20casual%20style%2C%20warm%20genuine%20smile%2C%20soft%20natural%20light%2C%20clean%20background&width=80&height=80&seq=saludo-ana&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'programa',
    destinoNombre: 'Tardes con Vale',
    destinoRadio: 'Estéreo Capital',
    estado: 'al_aire',
    fechaEnvio: '2026-06-21T14:10:00',
    fechaLeido: '2026-06-21T14:12:00',
    fechaDestacado: '2026-06-21T14:15:00',
    fechaAlAire: '2026-06-21T14:18:00',
    compartidos: 201,
    score: 402,
  },
  {
    id: 5,
    tipo: 'emoji',
    texto: 'Buen día a todos! Hoy amanecí con una energía increíble y quería compartirla con todo el equipo.',
    emoji: '☀️🎶💛',
    remitente: 'Natalia Campos',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20in%20her%2030s%2C%20warm%20friendly%20smile%2C%20casual%20chic%20style%2C%20soft%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=saludo-natalia&orientation=squarish',
    remitenteCiudad: 'Alajuela',
    destino: 'radio',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'leido',
    fechaEnvio: '2026-06-21T13:55:00',
    fechaLeido: '2026-06-21T13:58:00',
    compartidos: 45,
    score: 135,
  },
  {
    id: 6,
    tipo: 'texto',
    texto: 'Buen díaaaas! Saludos al equipo de Tardes de Pop, me acompañan en el gym todas las tardes y hacen mi rutina mucho más divertida. ¡Son lo máximo!',
    remitente: 'Camila Soto',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20modern%20trendy%20style%2C%20bright%20genuine%20smile%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=saludo-camila&orientation=squarish',
    remitenteCiudad: 'Cartago',
    destino: 'programa',
    destinoNombre: 'Tardes de Pop',
    destinoRadio: 'Radio Éxito FM',
    estado: 'leido',
    fechaEnvio: '2026-06-21T13:40:00',
    fechaLeido: '2026-06-21T13:45:00',
    compartidos: 32,
    score: 96,
  },
  {
    id: 7,
    tipo: 'texto',
    texto: 'Saludos desde Alajuela para todos los radioescuchas. Hoy cumplo 25 años de casado y quiero dedicarle un pensamiento a mi esposa Laura. ¡Gracias por acompañarnos siempre!',
    remitente: 'Pedro Gutiérrez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%20with%20kind%20eyes%2C%20simple%20casual%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=saludo-pedro&orientation=squarish',
    remitenteCiudad: 'Alajuela',
    destino: 'radio',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'leido',
    fechaEnvio: '2026-06-21T12:30:00',
    fechaLeido: '2026-06-21T12:35:00',
    compartidos: 56,
    score: 168,
  },
  {
    id: 8,
    tipo: 'imagen',
    texto: 'Hola equipo! Quería mandar un saludo muy especial a mi mamá que hoy está de cumpleaños. Ella me enseñó a amar la radio. Les mando una foto de nosotras escuchándolos juntas.',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Mother%20and%20daughter%20smiling%20together%20in%20a%20cozy%20living%20room%2C%20warm%20ambient%20light%2C%20radio%20on%20a%20wooden%20shelf%2C%20genuine%20happy%20moment%2C%20soft%20natural%20light%2C%20editorial%20style%2C%20clean%20composition&width=400&height=300&seq=saludo-maria-foto&orientation=landscape',
    remitente: 'María Fernanda López',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20friendly%20approachable%20expression%2C%20clean%20light%20background&width=80&height=80&seq=saludo-maria&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'locutor',
    destinoNombre: 'Diego Montenegro',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'al_aire',
    fechaEnvio: '2026-06-21T11:20:00',
    fechaLeido: '2026-06-21T11:25:00',
    fechaDestacado: '2026-06-21T11:30:00',
    fechaAlAire: '2026-06-21T11:35:00',
    compartidos: 178,
    score: 534,
  },
  {
    id: 9,
    tipo: 'texto',
    texto: 'Quiero mandar un abrazo enorme a toda la gente de Cartago que nos escucha. Especialmente al equipo de fútbol del barrio que ganó el campeonato. ¡Campeones!',
    remitente: 'Roberto Sánchez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20style%2C%20friendly%20expression%2C%20natural%20daylight%2C%20clean%20background&width=80&height=80&seq=saludo-roberto&orientation=squarish',
    remitenteCiudad: 'Cartago',
    destino: 'evento',
    destinoNombre: 'Final Campeonato Barrial 2026',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'al_aire',
    fechaEnvio: '2026-06-21T10:45:00',
    fechaLeido: '2026-06-21T10:50:00',
    fechaAlAire: '2026-06-21T10:52:00',
    compartidos: 340,
    score: 680,
  },
  {
    id: 10,
    tipo: 'texto',
    texto: 'Saluditos desde Heredia para Diego y Natalia. Son los mejores locutores del país. Me acompañan todas las tardes mientras pinto mis cuadros. ¡Son mi inspiración!',
    remitente: 'Valentina Castro',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20artistic%20style%2C%20creative%20look%2C%20warm%20smile%2C%20soft%20ambient%20light%2C%20clean%20background&width=80&height=80&seq=saludo-valentina&orientation=squarish',
    remitenteCiudad: 'Heredia',
    destino: 'locutor',
    destinoNombre: 'Diego Montenegro',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'destacado',
    fechaEnvio: '2026-06-21T10:10:00',
    fechaLeido: '2026-06-21T10:12:00',
    fechaDestacado: '2026-06-21T10:20:00',
    compartidos: 67,
    score: 201,
  },
  {
    id: 11,
    tipo: 'texto',
    texto: 'Saludos desde Heredia para todos los radioescuchas de la 98.7 FM. Sintonizándolos desde hace 15 años, el mejor acompañamiento para mis mañanas en el taller. ¡Pura vida!',
    remitente: 'Francisco Jiménez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Latino%20man%2C%20kind%20weathered%20face%2C%20simple%20style%2C%20natural%20lighting%2C%20warm%20expression%2C%20clean%20background&width=80&height=80&seq=saludo-francisco&orientation=squarish',
    remitenteCiudad: 'Heredia',
    destino: 'radio',
    destinoNombre: 'Radio Éxito FM 98.5',
    destinoRadio: 'Radio Éxito FM',
    estado: 'recibido',
    fechaEnvio: '2026-06-21T09:30:00',
    compartidos: 0,
    score: 10,
  },
  {
    id: 12,
    tipo: 'texto',
    texto: 'Solo quería agradecerles por el espacio que dan a artistas nacionales. Descubrí a Los Ecos gracias a ustedes y ahora soy fan número uno. ¡Sigan apoyando el talento tico!',
    remitente: 'Gabriela Mora',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20professional%20Latina%20woman%2C%20business%20casual%2C%20confident%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=saludo-gabriela&orientation=squarish',
    remitenteCiudad: 'Limón',
    destino: 'programa',
    destinoNombre: 'Modo Creativo',
    destinoRadio: 'Radio Élite Digital',
    estado: 'leido',
    fechaEnvio: '2026-06-21T08:45:00',
    fechaLeido: '2026-06-21T08:50:00',
    compartidos: 23,
    score: 69,
  },
  {
    id: 13,
    tipo: 'emoji',
    texto: 'Saludos a toda la banda de San José. Hoy andamos con toda la actitud positiva. Gracias por poner los temazos que alegran el sábado.',
    emoji: '🎧🔥💪🏽🎵',
    remitente: 'Javier Núñez',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20trendy%20street%20style%2C%20charismatic%20smile%2C%20urban%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=saludo-javier&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'radio',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'recibido',
    fechaEnvio: '2026-06-21T08:20:00',
    compartidos: 0,
    score: 10,
  },
  {
    id: 14,
    tipo: 'audio',
    texto: 'Buenas tardes a todos! Quiero mandar un saludo muy cariñoso a mi abuelita que está en el hospital. Abuelita, ¡te amamos y pronto vas a estar en casa! Este audio es para vos.',
    audioDuracion: '0:35',
    remitente: 'Lucía Mendoza',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20woman%20with%20warm%20genuine%20smile%2C%20natural%20makeup%2C%20casual%20look%2C%20soft%20natural%20light%2C%20clean%20bright%20background&width=80&height=80&seq=saludo-lucia&orientation=squarish',
    remitenteCiudad: 'Heredia',
    destino: 'locutor',
    destinoNombre: 'Valentina Ríos',
    destinoRadio: 'Estéreo Capital',
    estado: 'destacado',
    fechaEnvio: '2026-06-20T19:30:00',
    fechaLeido: '2026-06-20T19:35:00',
    fechaDestacado: '2026-06-20T19:40:00',
    compartidos: 289,
    score: 867,
  },
  {
    id: 15,
    tipo: 'imagen',
    texto: 'Saludos a la mejor radio del país. Los escucho desde que abrí mi cafetería en el centro y todos mis clientes ya son fans. Les mando una foto del crew cafetero.',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Group%20of%20friends%20enjoying%20coffee%20in%20a%20warm%20cozy%20cafeteria%2C%20smiling%20and%20waving%2C%20radio%20playing%20in%20the%20background%2C%20warm%20ambient%20lighting%2C%20friendly%20atmosphere%2C%20editorial%20style%2C%20clean%20composition&width=400&height=300&seq=saludo-diego-foto&orientation=landscape',
    remitente: 'Diego Vargas',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20stylish%20casual%20look%2C%20confident%20friendly%20expression%2C%20modern%20studio%20lighting%2C%20clean%20warm%20background&width=80&height=80&seq=saludo-diego&orientation=squarish',
    remitenteCiudad: 'Alajuela',
    destino: 'radio',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'recibido',
    fechaEnvio: '2026-06-20T17:15:00',
    compartidos: 0,
    score: 10,
  },
  {
    id: 16,
    tipo: 'texto',
    texto: 'Hola hola! Saludos a todo el team de la mañana. Hoy es mi primer día de vacaciones y lo primero que hice fue sintonizarlos. No hay mejor forma de empezar el día.',
    remitente: 'Daniela Quirós',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20fit%20Latina%20woman%2C%20sporty%20casual%20look%2C%20energetic%20smile%2C%20bright%20natural%20light%2C%20clean%20background&width=80&height=80&seq=saludo-daniela&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'radio',
    destinoNombre: 'Radio Deportiva Total 95.7',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'recibido',
    fechaEnvio: '2026-06-21T14:05:00',
    compartidos: 0,
    score: 10,
  },
  {
    id: 17,
    tipo: 'texto',
    texto: 'Un abrazo a todos los oyentes desde el Mercado Central. Aquí en la sodita los tenemos puestos todo el día. La clientela ya pide que no cambiemos de emisora. ¡Son parte de la familia!',
    remitente: 'Eduardo Paredes',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20man%2C%20casual%20professional%20style%2C%20friendly%20but%20serious%20expression%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=saludo-eduardo&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'radio',
    destinoNombre: 'Radio Éxito FM 98.5',
    destinoRadio: 'Radio Éxito FM',
    estado: 'leido',
    fechaEnvio: '2026-06-21T08:55:00',
    fechaLeido: '2026-06-21T09:00:00',
    compartidos: 41,
    score: 123,
  },
  {
    id: 18,
    tipo: 'texto',
    texto: 'Qué bonito programa el de hoy. Me encantó la entrevista con la banda nueva. Saludos para Carlos, mi esposo, que está en el taller escuchándonos. ¡Te amo mi vida!',
    remitente: 'Andrea Torres',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20woman%20with%20bright%20smile%2C%20everyday%20casual%20look%2C%20soft%20daylight%20studio%20lighting%2C%20friendly%20expression%2C%20clean%20light%20background&width=80&height=80&seq=saludo-andrea&orientation=squarish',
    remitenteCiudad: 'Cartago',
    destino: 'programa',
    destinoNombre: 'Mañanas Argentinas',
    destinoRadio: 'Radio Éxito FM',
    estado: 'destacado',
    fechaEnvio: '2026-06-21T09:40:00',
    fechaLeido: '2026-06-21T09:42:00',
    fechaDestacado: '2026-06-21T09:48:00',
    compartidos: 112,
    score: 336,
  },
  {
    id: 19,
    tipo: 'imagen',
    texto: 'Desde la playa en Guanacaste mandando un abrazo enorme a todos. Amanecimos con este paisaje increíble y quería compartirlo con la comunidad de RFW.',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20tropical%20beach%20at%20sunrise%20in%20Guanacaste%20Costa%20Rica%2C%20golden%20light%2C%20gentle%20waves%2C%20palm%20trees%2C%20peaceful%20atmosphere%2C%20warm%20sand%2C%20clean%20horizon%2C%20editorial%20travel%20photography&width=400&height=300&seq=saludo-playa-foto&orientation=landscape',
    remitente: 'Mauricio Chaves',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20beach%20casual%20style%2C%20tanned%20skin%2C%20bright%20confident%20smile%2C%20natural%20sunlight%2C%20clean%20background&width=80&height=80&seq=saludo-mauricio&orientation=squarish',
    remitenteCiudad: 'Guanacaste',
    destino: 'evento',
    destinoNombre: 'Summer Fest RFW 2026',
    destinoRadio: 'Estéreo Capital',
    estado: 'al_aire',
    fechaEnvio: '2026-06-20T16:20:00',
    fechaLeido: '2026-06-20T16:25:00',
    fechaAlAire: '2026-06-20T16:30:00',
    compartidos: 445,
    score: 890,
  },
  {
    id: 20,
    tipo: 'audio',
    texto: 'Hola a todos! Estoy celebrando mi graduación y quiero dedicar este momento a mis papás que siempre me apoyaron. ¡Lo logramos! Y gracias a ustedes por ser la banda sonora de mis años de estudio.',
    audioDuracion: '1:12',
    remitente: 'Jimena Rojas',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20in%20graduation%20cap%2C%20proud%20tearful%20smile%2C%20soft%20natural%20light%2C%20celebratory%20but%20tender%20expression%2C%20clean%20background&width=80&height=80&seq=saludo-jimena&orientation=squarish',
    remitenteCiudad: 'Cartago',
    destino: 'radio',
    destinoNombre: 'Radio Élite Digital 99.1',
    destinoRadio: 'Radio Élite Digital',
    estado: 'leido',
    fechaEnvio: '2026-06-21T09:15:00',
    fechaLeido: '2026-06-21T09:20:00',
    compartidos: 78,
    score: 234,
  },
  {
    id: 21,
    tipo: 'emoji',
    texto: 'Saludos desde Puntarenas. Hoy el puerto está hermoso y la brisa del mar nos tiene a todos de buen humor.',
    emoji: '🌊⚓🌴😎🎶',
    remitente: 'Óscar Fallas',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latino%20man%2C%20fisherman%20casual%20style%2C%20tanned%20skin%2C%20genuine%20wide%20smile%2C%20natural%20coastal%20light%2C%20clean%20background&width=80&height=80&seq=saludo-oscar&orientation=squarish',
    remitenteCiudad: 'Puntarenas',
    destino: 'radio',
    destinoNombre: 'Radio Éxito FM 98.5',
    destinoRadio: 'Radio Éxito FM',
    estado: 'recibido',
    fechaEnvio: '2026-06-21T08:10:00',
    compartidos: 0,
    score: 10,
  },
  {
    id: 22,
    tipo: 'texto',
    texto: 'Felicitaciones al equipo de Deporte Total por la cobertura de la final. La mejor transmisión deportiva que he escuchado en años. ¡Se pasaron!',
    remitente: 'Felipe Montero',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20sporty%20casual%20style%2C%20enthusiastic%20expression%2C%20natural%20light%2C%20clean%20background&width=80&height=80&seq=saludo-felipe&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'programa',
    destinoNombre: 'Deporte Total',
    destinoRadio: 'Radio Deportiva Total',
    estado: 'leido',
    fechaEnvio: '2026-06-20T23:45:00',
    fechaLeido: '2026-06-20T23:50:00',
    compartidos: 156,
    score: 468,
  },
  {
    id: 23,
    tipo: 'texto',
    texto: 'Desde la pista de baile en el evento de anoche. ¡Qué fiesta! RFW sabe cómo hacer eventos. Ya quiero el próximo. ¡Pura vida gente!',
    remitente: 'Mónica Salazar',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20party%20style%2C%20energetic%20joyful%20smile%2C%20vibrant%20lighting%2C%20clean%20background&width=80&height=80&seq=saludo-monica&orientation=squarish',
    remitenteCiudad: 'San José',
    destino: 'evento',
    destinoNombre: 'Noche de Baile RFW',
    destinoRadio: 'Estéreo Capital',
    estado: 'destacado',
    fechaEnvio: '2026-06-20T01:15:00',
    fechaLeido: '2026-06-20T01:20:00',
    fechaDestacado: '2026-06-20T01:25:00',
    compartidos: 198,
    score: 594,
  },
  {
    id: 24,
    tipo: 'texto',
    texto: 'Para Natalia, la mejor locutora de todas. Gracias por siempre leernos los saludos con tanto cariño. Sos el corazón del programa.',
    remitente: 'Carla Ureña',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20sweet%20friendly%20smile%2C%20everyday%20casual%20style%2C%20soft%20natural%20light%2C%20clean%20background&width=80&height=80&seq=saludo-carla&orientation=squarish',
    remitenteCiudad: 'Heredia',
    destino: 'locutor',
    destinoNombre: 'Natalia Vargas',
    destinoRadio: 'Radio Éxito FM',
    estado: 'leido',
    fechaEnvio: '2026-06-21T07:30:00',
    fechaLeido: '2026-06-21T07:35:00',
    compartidos: 34,
    score: 102,
  },
  {
    id: 25,
    tipo: 'imagen',
    texto: 'Buenos días desde el volcán! Subimos al Irazú esta mañana y desde acá arriba les mandamos un abrazo. La radio suena perfecto incluso a 3400 metros.',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Group%20of%20hikers%20at%20the%20summit%20of%20Irazu%20volcano%20in%20Costa%20Rica%2C%20clear%20blue%20sky%2C%20green%20crater%20lake%20visible%2C%20friends%20waving%20happily%2C%20bright%20morning%20light%2C%20adventure%20photography&width=400&height=300&seq=saludo-volcan-foto&orientation=landscape',
    remitente: 'Grupo Aventura CR',
    remitenteAvatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20group%20of%20young%20Latino%20friends%2C%20hiking%20gear%2C%20outdoors%20adventure%20style%2C%20joyful%20expressions%2C%20bright%20mountain%20light%2C%20clean%20background&width=80&height=80&seq=saludo-aventura&orientation=squarish',
    remitenteCiudad: 'Cartago',
    destino: 'radio',
    destinoNombre: 'Estéreo Capital 102.1',
    destinoRadio: 'Estéreo Capital',
    estado: 'recibido',
    fechaEnvio: '2026-06-21T06:45:00',
    compartidos: 0,
    score: 10,
  },
];

export const scoreAccionesSaludos: ScoreAccionSaludo[] = [
  {
    id: 'enviar',
    accion: 'Enviar Saludo',
    icono: 'ri-message-3-line',
    color: 'from-rose-500 to-pink-500',
    descripcion: 'Sumás 10 puntos cada vez que enviás un saludo con texto, audio, emoji o imagen.',
    puntos: 10,
  },
  {
    id: 'recibir-destacado',
    accion: 'Recibir Destacado',
    icono: 'ri-star-line',
    color: 'from-amber-500 to-yellow-500',
    descripcion: 'Sumás 25 puntos cuando tu saludo es destacado por el locutor en Cabina.',
    puntos: 25,
  },
  {
    id: 'compartir',
    accion: 'Saludo Compartido',
    icono: 'ri-share-forward-line',
    color: 'from-emerald-500 to-teal-500',
    descripcion: 'Sumás 5 puntos por cada persona que comparte tu saludo en la comunidad.',
    puntos: 5,
  },
];

export const reglasSaludos: ReglaSaludo[] = [
  {
    id: 1,
    titulo: 'Todo saludo vive dentro de Cabina',
    descripcion: 'Enviar, recibir, leer, destacar y mover al aire — toda la interacción con saludos sucede exclusivamente en la Cabina. No existen formularios de saludos en ninguna otra parte de la plataforma. La Cabina es el único canal.',
    icono: 'ri-broadcast-line',
    color: 'from-rose-500 to-pink-500',
  },
  {
    id: 2,
    titulo: 'Cuatro formas de saludar',
    descripcion: 'Texto: escribí lo que quieras. Audio: grabá tu voz (máximo 2 minutos). Emoji: elegí hasta 5 emojis para expresarte. Imagen: subí una foto para acompañar tu saludo. La variedad de formatos hace cada saludo único.',
    icono: 'ri-chat-smile-2-line',
    color: 'from-violet-500 to-purple-500',
  },
  {
    id: 3,
    titulo: 'Cuatro destinos posibles',
    descripcion: 'Radio: saludá a toda la comunidad de una radio. Programa: dedicá tu saludo a un programa específico. Locutor: mandale un mensaje directo a tu locutor favorito. Evento: sumate a la conversación de un evento en vivo.',
    icono: 'ri-compass-3-line',
    color: 'from-emerald-500 to-green-500',
  },
  {
    id: 4,
    titulo: 'Tu saludo tiene vida propia',
    descripcion: 'Cada saludo pasa por estados visibles: Recibido → Leído → Destacado → Al Aire. El oyente siempre sabe dónde está su saludo. Si es destacado o llega al aire, el score se multiplica y la comunidad lo celebra.',
    icono: 'ri-pulse-line',
    color: 'from-amber-500 to-orange-500',
  },
];

export const globalStatsSaludos = {
  saludosHoy: 287,
  saludosAlAire: 42,
  saludosDestacados: 18,
  tiposTexto: 156,
  tiposAudio: 48,
  tiposEmoji: 53,
  tiposImagen: 30,
  scoreTotalGenerado: 8745,
  saludoMasCompartido: 'Lucía Mendoza - Audio a su abuelita',
};

export const tipoLabels: Record<TipoSaludo, { label: string; icono: string; color: string }> = {
  texto: { label: 'Texto', icono: 'ri-text', color: 'text-foreground-600 bg-foreground-100' },
  audio: { label: 'Audio', icono: 'ri-mic-line', color: 'text-violet-600 bg-violet-100' },
  emoji: { label: 'Emoji', icono: 'ri-emotion-line', color: 'text-amber-600 bg-amber-100' },
  imagen: { label: 'Imagen', icono: 'ri-image-line', color: 'text-sky-600 bg-sky-100' },
};

export const estadoLabelsSaludo: Record<EstadoSaludo, { label: string; icono: string; dot: string }> = {
  recibido: { label: 'Recibido', icono: 'ri-mail-line', dot: 'bg-foreground-400' },
  leido: { label: 'Leído', icono: 'ri-mail-open-line', dot: 'bg-primary-500' },
  destacado: { label: 'Destacado', icono: 'ri-star-fill', dot: 'bg-amber-500' },
  al_aire: { label: 'Al Aire', icono: 'ri-broadcast-fill', dot: 'bg-emerald-500 animate-pulse' },
};

export const destinoLabels: Record<DestinoSaludo, { label: string; icono: string }> = {
  radio: { label: 'Radio', icono: 'ri-radio-line' },
  programa: { label: 'Programa', icono: 'ri-calendar-event-line' },
  locutor: { label: 'Locutor', icono: 'ri-user-voice-line' },
  evento: { label: 'Evento', icono: 'ri-calendar-check-line' },
};

export function getSaludosPorEstado(estado: EstadoSaludo): Saludo[] {
  return saludos.filter((s) => s.estado === estado);
}

export function getSaludosPorTipo(tipo: TipoSaludo): Saludo[] {
  return saludos.filter((s) => s.tipo === tipo);
}

export function getSaludosPorDestino(destino: DestinoSaludo): Saludo[] {
  return saludos.filter((s) => s.destino === destino);
}

export function getMasCompartidos(): Saludo[] {
  return [...saludos].sort((a, b) => b.compartidos - a.compartidos);
}

export function getMayorScore(): Saludo[] {
  return [...saludos].sort((a, b) => b.score - a.score);
}

export function getMasRecientes(): Saludo[] {
  return [...saludos].sort((a, b) => new Date(b.fechaEnvio).getTime() - new Date(a.fechaEnvio).getTime());
}